<template>
  <div id="render"
  @mouseenter="particleMoveActive = false"
  @mouseleave="particleMoveActive = true"
  @click="particleHitBig">
    <img :src="`img/renders/${renderImage}.png`" id="render-img" alt="Featured Image Render">
  </div>
</template>

<script>
import { CanvasSpace, Create, World, Particle, Num, Pt } from 'pts'

export default {
  data () {
    return {
      particleAmt: 10,
      particleCursorSize: 25,
      particleBaseSize: 25,
      particleSizeModifier: 12,
      particleHitAmt: 15,
      particleMoveActive: true,
      particleHitTimer: 500,
      particles: []
    }
  },
  props: {
    'particleBGColor': {
      type: String,
      default: 'grey'
    },
    'particleColor': {
      type: String,
      default: 'white'
    },
    'renderImage': {
      type: String,
      required: true
    }
  },
  methods: {
    moveParticles () {
      this.particles.forEach(particle => {
        particle.hit(Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5), Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5))
      })
    },
    particleHitBig () {
      this.particles.forEach(particle => {
        particle.hit(Num.randomRange(-this.particleHitAmt * 5, this.particleHitAmt * 5), Num.randomRange(-this.particleHitAmt * 5, this.particleHitAmt * 5))
      })
    }
  },
  mounted () {
    var space = new CanvasSpace('#render').setup({ bgcolor: 'transparent', resize: true, retina: true })
    var form = space.getForm()

    var world
    // let particles =[];
    let particleSize

    window.innerWidth >= 900 ? particleSize = this.particleBaseSize : particleSize = this.particleBaseSize / 2

    space.add({

      start: (bound, space) => {
        // Create world and 100 random points
        world = new World(space.innerBound, 1, 0)
        let pts = Create.distributeRandom(space.innerBound, this.particleAmt)

        // Create particles and hit them with a random impulse
        for (let i = 0, len = pts.length; i < len; i++) {
          let p = new Particle(pts[i]).size((i === 0) ? particleSize : particleSize + Math.random() * space.size.x / this.particleSizeModifier)
          p.hit(Num.randomRange(-this.particleHitAmt, this.particleHitAmt), Num.randomRange(-this.particleHitAmt / 2, this.particleHitAmt / 2))
          world.add(p)
          this.particles.push(p)
        }

        if (window.innerWidth >= 900) {
          world.particle(0).lock = true // lock it to move it by pointer later on
        }

        setInterval(() => {
          if (this.particleMoveActive) {
            this.moveParticles()
          }
        }, this.particleHitTimer)
      },

      animate: (time, ftime) => {
        world.drawParticles((p, i) => {
          let color = this.$props.particleColor
          form.fillOnly(color).point(p, p.radius, 'circle')
        })

        world.update(ftime)
      },

      action: (type, px, py) => {
        if (window.innerWidth >= 900) {
          if (type === 'move') {
            world.particle(0).position = new Pt(px, py)
          }
        }
      },

      resize: (bound, evt) => {
        if (world) world.bound = space.innerBound
      }
    })

    space.bindMouse().bindTouch()
    space.play()
  }

}

</script>

<style lang="scss" scoped>
  #render {
    cursor: none;
    transition: background-color .5s ease-out;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    //margin: $grid-gap-negative;
    width: 45%;
    height: 100%;

    @include tablet-below {
      width: 100%;
      height: 350px;
      margin: 0 $grid-gap;
      cursor: pointer;
    }

    @include phone-only {
      pointer-events: none;
    }

    img {
      width: 80%;
      max-width: 360px;
      position: absolute;
      pointer-events: none;
      user-select: none;

      @include tablet-below {
        width: 60%;
      }
    }
  }
</style>
